import './index.less'
import classNames from "classnames";
import React, { CSSProperties, ForwardRefExoticComponent, ReactNode, useContext } from "react";
import { CollapsePlusContext } from '../CollapsePlusUI';

export interface CollapseItemPlusUIProps {
    className?: string,
    index: any,
    title?: string,
    style?: CSSProperties | undefined;
    icon?: ReactNode
    onClick?: (index: number) => boolean;
}

const CollapseItemPlusUI = (props: CollapseItemPlusUIProps, ref) => {
    const { className, index, title, style, icon, onClick } = props

    const prefixCls = 'collapse-item-plus-ui'
    const context = useContext(CollapsePlusContext)
    const classnames = classNames([
        prefixCls,
        context.index === index ? `${prefixCls}-select` : '',
        className
    ])

    return (<div className={classnames} style={style} onClick={() => {
        if (onClick && onClick(index)) {
            context.onSelect(index, true)
        } else if (!onClick) {
            context.onSelect(index, true)
        } else {
            context.onSelect(index, false)
        }
    }}>
        <div className='l'>{icon}</div>
        <span className='r'>{title}</span>
    </div>)
}

export type CollapseItemPlusType = ForwardRefExoticComponent<CollapseItemPlusUIProps> & {
    isCollapseItemPlus: boolean;
}

export const CollapseItemPlusRef: CollapseItemPlusType = React.forwardRef(CollapseItemPlusUI) as CollapseItemPlusType;

CollapseItemPlusRef.displayName = 'CollapseItemPlusUI'
CollapseItemPlusRef.isCollapseItemPlus = true;

export default CollapseItemPlusRef
